import { IPresenter } from "../presenters/Presenter";

export abstract class Controller<TPresenter extends IPresenter> {
  public constructor(protected presenter: TPresenter) {
    presenter.init();
  }
}
